/**
 * Never edit this file manually. It is generated as part of the building process
 */
export const AppInfo = {
    name: 'ystm-client',
    version: '3.21.9'
};

